import { z } from 'zod';

import {
  BaseFlowBlockSchema,
  BlockType,
  ConsumerOfConditionsSchema,
  ConsumerOfDocumentExtractSchema,
  ConsumerOfLabValuesSchema,
  ConsumerOfMedicationsSchema,
  ConsumerOfSurgicalHistoriesSchema,
  ProducedType,
  returnTypeSchema,
} from '../base/baseSchema.js';

export enum CareGapAlgorithm {
  BloodPressureControlDiabetes = 'BLOOD_PRESSURE_CONTROL_DIABETES',
  CervicalCancerScreening = 'CERVICAL_CANCER_SCREENING',
  ColonCancerHighRisk = 'COLON_CANCER_SCREEN_HIGH_RISK',
  DiabetesEyeExam = 'DIABETES_EYE_EXAM',
  DiabetesHbA1cMonitoring = 'DIABETES_HBA1C_MONITORING',
  DiabetesNephropathyMonitoring = 'DIABETES_NEPHROPATHY_MONITORING',
  Hypertension = 'HYPERTENSION',
  KidneyHealthEvaluationDiabetes = 'KIDNEY_HEALTH_EVALUATION_FOR_PATIENTS_WITH_DIABETES',
  OsteoporosisScreeningOlderWomen = 'OSTEOPOROSIS_SCREENING_OLDER_WOMEN',
  PreventiveCareBreastCancerScreeningForWomenFrom50To75 = 'PREVENTIVE_CARE_BREAST_CANCER_SCREENING_RECOMMENDED_EVERY_1_2_YEARS_FOR_WOMEN_BETWEEN_AGES 50_75_YEARS',
  PreventiveCareColonCancerScreen = 'PREVENTIVE_CARE_COLON_CANCER_SCREEN',
  PreventiveCarePapSmear = 'PREVENTIVE_CARE_PAP_SMEAR',
  StatinTherapyCardiovascular = 'STATIN_THERAPY_CARDIOVASCULAR',
  StatinTherapyDiabetes = 'STATIN_THERAPY_DIABETES',
}

export const CareGapAlgorithmBlockConfigSchema = z.object({
  algorithm: z.enum(CareGapAlgorithm, { message: 'Algorithm is required' }),
  payload: z.object({
    documents: ConsumerOfDocumentExtractSchema,
    labValues: ConsumerOfLabValuesSchema,
    medications: ConsumerOfMedicationsSchema,
    problems: ConsumerOfConditionsSchema,
    procedures: ConsumerOfSurgicalHistoriesSchema,
  }),
});
export type CareGapAlgorithmBlockConfig = z.infer<typeof CareGapAlgorithmBlockConfigSchema>;

export const CareGapAlgorithmBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.CareGapAlgorithmBlock),
  config: CareGapAlgorithmBlockConfigSchema,
  returnType: returnTypeSchema(ProducedType.PatientFindings),
});
export type CareGapAlgorithmBlock = z.infer<typeof CareGapAlgorithmBlockSchema>;

interface EvidenceDataFields {
  providerName?: string;
  providerSpecialty?: string;
  location?: string;
  documentDate?: Date;
  impressionAndRecommendation?: string;
  recallDuration?: string;
  source: string;
  testName?: string;
  testDate?: string;
  testValue?: number;
  testResult?: string;
}

interface Evidence {
  problemListId: string | null;
  patientDocumentId: string | null;
  medicationListId: string | null;
  ehrInformationId: string;
  data: EvidenceDataFields;
  reviewState: string;
  rejectionReason: string | null;
  exportState: string;
}

export interface Finding {
  type: string;
  ehrInformationId: string;
  encounterId?: string | null;
  patientAdvisoryId?: string | null;
  icd10?: string | null;
  hccCode?: string | null;
  suspectText?: string | null;
  careGapType?: string | null;
  status: string;
  reviewState: string;
  reviewed?: Date | null;
  rejectionReason?: string | null;
  exportState: string;
  evidence?: Evidence[] | null;
}
